import { compact } from 'lodash';
import { useContext } from 'react';
import { TestableContext } from '../contexts';
export const TEST_ID_PROP_NAME = 'data-test-id';

const useTestId = () => {
  const idPath = useContext(TestableContext);

  const generateTestIdProps = (...args) => ({
    [TEST_ID_PROP_NAME]: compact([...idPath, ...args]).join('.')
  });

  const generateTestId = (...args) => generateTestIdProps(...args)[TEST_ID_PROP_NAME];

  return {
    generateTestIdProps,
    generateTestId
  };
};

export default useTestId;